<template>
  <div class="text-with-label-component" :class="{ '--dense': dense }">
    <div class="label">{{ label }}</div>
    <div class="text">{{ text }}</div>
  </div>
</template>

<script>
	export default {
		name: 'TextWithLabel',

		props: {
      text: String,
      label: String,
      dense: {
        type: Boolean,
        default: false
      }
    }
	}
</script>

<style lang="scss">
  @import '@/styles/components/textWithLabel.scss';
</style>
